import "./OutlineButton.scss";
import { Link } from "react-router-dom";

export default function OutlineButton({
  type,
  children,
  onClick,
  className,
  route,
}) {
  if (!route) {
    return (
      <button
        type={type}
        onClick={onClick}
        className={`button button--outline ${className}`}
      >
        {children}
      </button>
    );
  }

  return (
    <Link to={route} className={`button button--outline ${className}`}>
      {children}
    </Link>
  );
}
